import { render } from "./Greeting.vue?vue&type=template&id=4d910d32&scoped=true&ts=true"
import script from "./Greeting.vue?vue&type=script&lang=ts"
export * from "./Greeting.vue?vue&type=script&lang=ts"

import "./Greeting.vue?vue&type=style&index=0&id=4d910d32&scoped=true&lang=scss"

import exportComponent from "/Users/matthias/Code/uniki/vergabe/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d910d32"]])

export default __exports__